/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { getAlertColor } from '@components/ui/Notification';
import {
  NotificationAPIContext,
  NotificationStateContext,
} from '@components/ui/Notification/NotificationContext';
import { SnackbarCloseReason } from '@mui/material';
import { FC, useContext } from 'react';

import { Snackbar } from '../Snackbar';

const NotificationSnackbar: FC = () => {
  const { hideNotification } = useContext(NotificationAPIContext);
  const { open, notification } = useContext(NotificationStateContext);

  if (!notification) {
    return null;
  }

  const handleClose = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (notification?.onClose) {
      notification.onClose();
    }
    hideNotification();
  };

  return (
    <Snackbar
      open={open}
      handleClose={handleClose}
      duration={notification.duration || 6000}
      severity={getAlertColor(notification.type)}
      message={notification.message}
      title={notification.title}
    />
  );
};

export default NotificationSnackbar;
